module.exports = __webpack_public_path__ + "static/media/front.6e035aee.png";